module.exports = __webpack_public_path__ + "static/media/Industriekessel_02.c98f94de.jpg";